export default "__VITE_ASSET__KG8S6xXN__"